export default __webpack_public_path__ + "static/media/trait-gender.a00f16d3.png";